import React from "react";
import Header from "./Header";
import Hero from "./Hero";
import About from "./About";
import Services from "./Services";
import Contact from "./Contact";
import Footer from "./Footer";

export default function Home() {
  return (
    <>
      <Header />
      <Hero />
            <Services />

      <About />
      <Contact />
      <Footer />
    </>
  );
}
